export const DocumentDownloadIcon = ({ color = 'currentColor', width = 24, height = 24 }: { color?: string; width?: number; height?: number }) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9 13L12 16M12 16L15 13M12 16V8M6 20H18C19.1046 20 20 19.1046 20 18V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L15.5858 3.58579C15.2107 3.21071 14.702 3 14.1716 3H6C4.89543 3 4 3.89543 4 5V18C4 19.1046 4.89543 20 6 20Z'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
